import _ from 'underscore';

export const toggleState = {
  on: 'on',
  indeterminate: 'indeterminate',
  off: 'off',
};

const toggleMode = {
  default: 'default',
  triState: 'triState',
};

const toggleStateAutomaton = {
  default: {
    on: 'off',
    indeterminate: 'on',
    off: 'on',
  },
  triState: {
    on: 'indeterminate',
    indeterminate: 'off',
    off: 'on',
  },
};

export default class ViewModel {
  constructor({
    mode = toggleMode.default,
    state = toggleState.off,
    enabled = true,
    onchange = _.noop,
  }) {
    this.reset({
      mode,
      state,
      enabled,
    });

    this.onchange = onchange;
  }

  toggle() {
    if (this.enabled) {
      this.state = toggleStateAutomaton[this.mode][this.state];
      this.onchange(this.state);
    }
  }

  setToggleState(state) {
    if (_.has(toggleState, state) && this.state !== state) {
      this.state = state;
      this.onchange(this.state);
    }
  }

  reset({
    mode = this.mode,
    state = this.state,
    enabled = this.enabled,
  }, callback = _.noop) {
    this.mode = mode;
    this.state = state;
    this.enabled = enabled;
    callback();
  }
}
